@if (cart$ | async; as cart) {
  @if (entries$ | async; as entries) {
    @if (cart.totalItems > 0) {
      <div class="cart-details-wrapper">
        <div class="mt-3">
          <div class="cx-total">{{ 'cartDetails.cartName' | cxTranslate }} {{ cart.code }}</div>
        </div>
        <app-custom-cart-item-list
          [items]="entries"
          [cartIsLoading]="!(cartLoaded$ | async)"
          [promotionLocation]="promotionLocation"
        [options]="{
          isSaveForLater: false,
          optionalBtn: saveForLaterBtn
        }"
          (itemRemoved)="onItemRemoved()"
          [showAllStatus]="true"
          >
        </app-custom-cart-item-list>
      </div>
    }
  }
}

@if (cart$ | async; as cart) {
  <app-custom-cart-product-references
    [cartCode]="cart.code"
    [cartItemRemoved]="resetCartProductReferences.asObservable()"
    >
  </app-custom-cart-product-references>
}

<ng-template let-ctx #saveForLaterBtn>
  @if (selectiveCartEnabled) {
    <div class="col-md-3 col-lg-3 col-xl-3 cx-sfl-btn">
      <button class="link cx-action-link" [disabled]="ctx.loading" (click)="saveForLater(ctx.item)" type="button">
        {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
      </button>
    </div>
  }
</ng-template>
